import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const getUserRedirect = (user) => {
  if (!user) return "/admin/login";
  if (user.role === "admin") return "/admin";
  if (user.can_access_panel) return "/painel";
  return "/admin/login";
};

const AdminLogin = () => {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user) navigate(getUserRedirect(user), { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Bem-vindo de volta!");
    } else {
      toast.error(res.error);
    }
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Carregando…</div>;

  return (
    <div className="min-h-screen flex items-center justify-center bg-primary px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center mb-10 text-primary-foreground/70 hover:text-accent text-sm">← Voltar ao site</Link>
        <div className="bg-white rounded-3xl p-8 md:p-10 shadow-2xl">
          <div className="text-center mb-8">
            <div className="w-14 h-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center mx-auto mb-4">
              <Lock className="w-6 h-6" />
            </div>
            <h1 className="font-display text-2xl text-primary mb-1">Acesso Restrito</h1>
            <p className="text-sm text-muted-foreground">Faça login para administrar o site.</p>
          </div>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="text-xs uppercase tracking-widest text-muted-foreground">E-mail</label>
              <div className="mt-1 relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 bg-secondary/30 rounded-xl outline-none focus:bg-white border border-transparent focus:border-primary"
                  placeholder="seu@email.com"
                  data-testid="admin-login-email"
                />
              </div>
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-muted-foreground">Senha</label>
              <div className="mt-1 relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 bg-secondary/30 rounded-xl outline-none focus:bg-white border border-transparent focus:border-primary"
                  placeholder="••••••••"
                  data-testid="admin-login-password"
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={submitting}
              className="w-full py-3 rounded-full bg-primary text-primary-foreground font-medium hover:bg-primary/90 transition-all disabled:opacity-60"
              data-testid="admin-login-submit"
            >
              {submitting ? "Entrando..." : "Entrar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
